module.exports = __webpack_public_path__ + "img/calendar.53d44d78.svg";